
var id = "clear";
var markup = "<symbol viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"clear\">\n    <title>切片</title>\n    <defs>\n        <polygon id=\"clear_path-1\" points=\"23.3333333 2.35 20.9833333 -5.68434189e-14 11.6666667 9.31666667 2.35 -5.68434189e-14 0 2.35 9.31666667 11.6666667 0 20.9833333 2.35 23.3333333 11.6666667 14.0166667 20.9833333 23.3333333 23.3333333 20.9833333 14.0166667 11.6666667\" />\n    </defs>\n    <g id=\"clear_小程序素材管理\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"clear_小程序素材管理-编辑-图片查看\" transform=\"translate(-1110.000000, -226.000000)\">\n            <g id=\"clear_content/clear_24px\" transform=\"translate(1118.333333, 234.333333)\">\n                <mask id=\"clear_mask-2\" fill=\"white\">\n                    <use xlink:href=\"#clear_path-1\" />\n                </mask>\n                <g id=\"clear_icon/content/clear_24px\" fill-rule=\"nonzero\"></g>\n                <g id=\"clear_编组\" mask=\"url(#clear_mask-2)\">\n                    <g transform=\"translate(-8.333333, -8.333333)\" id=\"clear_↳-Color\">\n                        <rect id=\"clear_Rectangle\" fill=\"#FFFFFF\" x=\"0\" y=\"0\" width=\"40\" height=\"40\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
